import { differenceInMonths } from 'date-fns';
/**
 * Разница в месяцах между двумя датами
 * @example new Date(2020, 6, 14), new Date(2019, 6, 14) => 12
 */
export const dateDiffMonths = (a: Date, b: Date) => {
  return differenceInMonths(a, b);
};
